module.exports = __webpack_public_path__ + "static/media/fg-right-palm.3d6780ec.svg";